import { api } from '../../services/api';

const DASHBOARD_URL = '/main/';

export const getData = (filters) =>
  api.get(`${DASHBOARD_URL}?${filters}`);
